<template>
  <div class="home-page">
    <page_head class="page-top"></page_head>
    <div class="page-content">
      <left_bar_to></left_bar_to>
      <div class="right-content">
        <router-view></router-view>
        <div class="content-map" :class="{'hide-map': path!=='/tobacco'}">
          <chart_map></chart_map>
        </div>
        <switch_map_btn mapPathName="tobacco"></switch_map_btn>
      </div>
    </div>
    <loading></loading>
  </div>
</template>

<script>
  import ChartMap from '@/view/map'
  import LeftBarTo from '../../components/LeftBarTo'
  import PageHeadTo from '../../components/PageHeadTo'
  import SwitchMapBtn from '../../components_bit/SwitchMapBtn'
  import Loading from '../../components_bit/Loading'
  export default {
    components: {
      chart_map: ChartMap,
      left_bar_to: LeftBarTo,
      page_head: PageHeadTo,
      switch_map_btn: SwitchMapBtn,
      loading: Loading
    },
    created () {
      this.$store.dispatch('getCaseList')
      if (this.solutionStatus === 0 && this.$router.history.current.name === 'cycle') {
        this.$router.push({name: 'import'})
      }
    },
    computed: {
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      path: {
        get () {
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .hide-map {
    z-index: -1;
  }
  .home-page {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .page-content {
      display: flex;
      flex-direction: row;
      flex:1;
      .right-content {
        flex:1;
        display: flex;
        overflow:auto;
        background-color: #efefef;
      }
    }
  }
  .page-top {
    z-index: 4;
  }
  .right-content::-webkit-scrollbar {
    display: none;
  }
  .content-map {
    position: absolute;
    top: 6.13em;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// index.vue?677c457a